<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-overlay :value="!loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
 <Strong>Note : If any data is not available or applicable, kindly mention NA</Strong>
    <v-form
      id="address_form"
      @submit.prevent="submit"
      v-model="isValid"
      v-if="loader"
    >

<!-- {{preferred_communication_address}} -->
        <v-row dense justify="center" v-if="tenant=='uwws'">
            <v-col cols="12" sm="12" md="12" v-if="preferred_communication_address"> 
               <v-icon color="error" v-if="preferred_communication_address.required">*</v-icon>
           <v-autocomplete
            dense
            v-model="preferred_communication_address.field_value"
            :items="status_list"
            name="preferred_communication_address"
            :required="preferred_communication_address"
            :rules="
              preferred_communication_address.required
                ? [(v) => !!v || ' Preffered Communication Address Is Required']
                : []
            "
            :clearable="preferred_communication_address.required ? false : true"
            return-object
            item-text="name"
            single-line
            :prepend-icon="
              preferred_communication_address != null
                ? 'mdi-flag'
                : 'mdi-flag-variant-outline'
            "
            outlined
            hint="Preffered Communication Address"
            persistent-hint
          ></v-autocomplete>
 
            </v-col>
       </v-row> 

      <v-row dense justify="center">
        <v-col cols="10" sm="10" md="10">
          <input
            type="hidden"
            :value="application_form_data.admission_form_id"
            name="admission_form_id"
          /> </v-col
      ></v-row>
      <v-row dense justify="center" v-if="local_address">
        <v-col cols="10" sm="10" md="10">
          <center><h3>{{ local_address.field_display_name }}</h3> </center> 
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="local_address != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="local_address.required">*</v-icon>
          <v-textarea
            dense
            :value="local_address.laddress"
            v-model="local_address.laddress"
            name="laddress"
            :required="local_address.required"
            :rules="
              local_address.required
                ? [
                    (v) =>
                      !!v || local_address.field_display_name + ' is required',
                  ]
                : []
            "
            :clearable="local_address.required ? false : true"
            hint="Address"
            persistent-hint
            :prepend-icon="
              local_address.laddress != null ? 'mdi-home' : 'mdi-home-outline'
            "
            outlined
          ></v-textarea> </v-col
      >
      </v-row>

      <v-row dense justify="center" v-if="local_address != null">
         <v-col cols="10" sm="5" md="5">
          <v-icon color="error" v-if="local_address.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="local_address.lcity"
            :items="cities_list_local"
            name="lcity"
            :required="local_address.lcity"
            :rules="
              local_address.lcity ? [(v) => !!v || ' City is required'] : []
            "
            :clearable="local_address.lcity ? false : true"
            return-object
            single-line
            :prepend-icon="
              local_address.lcity != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="City"
            persistent-hint
          ></v-autocomplete>
        </v-col>
        
         <!-- <v-col cols="10" sm="5" md="5">
          <v-icon color="error" v-if="local_address.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="local_address.ldistrict"
            :items="district_list"
            name="ldistrict"
            :required="local_address.ldistrict"
            :rules="
              local_address.ldistrict ? [(v) => !!v || ' District is required'] : []
            "
            :clearable="local_address.ldistrict ? false : true"
            return-object
            single-line
            :prepend-icon="
              local_address.ldistrict != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="District"
            persistent-hint
          ></v-autocomplete>
        </v-col> -->
        <v-col cols="5" sm="5" md="5">
          <v-icon color="error" v-if="local_address.required">*</v-icon>
          <v-text-field
            dense
            v-model="local_address.lpin"
            name="lpin"
            :required="local_address.required"
            type="number"
            :rules="
              local_address.required ? [(v) => !!v || ' Pin is required'] : []
            "
            :clearable="local_address.required ? false : true"
            return-object
            single-line
            :prepend-icon="
              local_address.lpin != null
                ? 'mdi-map-marker'
                : 'mdi-map-marker-outline'
            "
            outlined
            hint="Pincode"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="local_address != null">
        
        <v-col cols="5" sm="5" md="5">
          <v-icon color="error" v-if="local_address.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="local_address.lstate"
            :items="state_list"
            name="lstate"
            :required="local_address.lstate"
            :rules="
              local_address.lstate ? [(v) => !!v || ' State is required'] : []
            "
            :clearable="local_address.lstate ? false : true"
            return-object
            single-line
            :prepend-icon="
              local_address.lstate != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="State"
            persistent-hint
            @change="getCitiesLocal(local_address.lstate)"
          ></v-autocomplete>
        </v-col>
        <v-col cols="10" sm="5" md="5">
          <v-icon color="error" v-if="local_address.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="local_address.lcountry"
            :items="country_list"
            name="lcountry"
            :required="local_address.required"
            :rules="
              local_address.required
                ? [(v) => !!v || ' Country is required']
                : []
            "
            :clearable="local_address.required ? false : true"
            return-object
            single-line
            :prepend-icon="
              local_address.lcountry != null
                ? 'mdi-flag'
                : 'mdi-flag-variant-outline'
            "
            outlined
            hint="Country"
            persistent-hint
            @change="getStates(local_address.lcountry)"
          ></v-autocomplete>
        </v-col>
      </v-row>

       <v-row dense justify="center" v-if="local_address != null">
          <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="local_address.required">*</v-icon>
          <v-textarea
            dense
            :value="local_address.lnearest_landmark"
            v-model="local_address.lnearest_landmark"
            name="lnearest_landmark"
            :required="local_address.required"
            :rules="
              local_address.required
                ? [
                    (v) =>
                      !!v || local_address.field_display_name + ' is required',
                  ]
                : []
            "
            :clearable="local_address.required ? false : true"
            hint=" Nearest Landmark"
            persistent-hint
            :prepend-icon="
              local_address.laddress != null ? 'mdi-home' : 'mdi-home-outline'
            "
            outlined
          ></v-textarea> </v-col
      >
       
        <!-- <v-col cols="5" sm="5" md="5">
          <v-icon color="error" v-if="local_address.required">*</v-icon>
          <v-text-field
            dense
            v-model="local_address.ltaluka"
            name="ltaluka"
            :required="local_address.ltaluka"
            type="text"
            :rules="
              local_address.required ? [(v) => !!v || ' Taluka is required'] : []
            "
            :clearable="local_address.required ? false : true"
            return-object
            single-line
            :prepend-icon="
              local_address.ltaluka != null
                ? 'mdi-map-marker'
                : 'mdi-map-marker-outline'
            "
            outlined
            hint="Taluka"
            persistent-hint
          ></v-text-field>
        </v-col> -->

        
      </v-row> 

      <hr color="grey lighten-1" v-if="permanent_address" />

      <v-row
        dense
        justify="center"
        v-if="permanent_address != null && local_address != null"
      >
        <v-col cols="10" sm="10" md="10">
          <v-checkbox
            v-model="pladdress"
            color="primary darken-1"
            :label="`Whether Permanent Address is same as ${local_address.field_display_name}`"
            @change="copyAddress()"
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="permanent_address">
        <v-col cols="10" sm="10" md="10">
          <center><h3>{{ permanent_address.field_display_name }}</h3></center>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="permanent_address != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="permanent_address.required">*</v-icon>
          <v-textarea
            dense
            :value="permanent_address.paddress"
            v-model="permanent_address.paddress"
            name="paddress"
            :required="permanent_address.required"
            :rules="
              permanent_address.required
                ? [
                    (v) =>
                      !!v ||
                      permanent_address.field_display_name + ' is required',
                  ]
                : []
            "
            :clearable="permanent_address.required ? false : true"
            hint="Address"
            persistent-hint
            :prepend-icon="
              permanent_address.paddress != null
                ? 'mdi-home'
                : 'mdi-home-outline'
            "
            outlined
          ></v-textarea> </v-col
      ></v-row>
      <v-row dense justify="center" v-if="permanent_address != null">
       
        <v-col cols="5" sm="5" md="5">
          <v-icon color="error" v-if="permanent_address.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="permanent_address.pcountry"
            :items="country_list"
            name="pcountry"
            :required="permanent_address.required"
            :rules="
              permanent_address.required
                ? [(v) => !!v || ' Country is required']
                : []
            "
            :clearable="permanent_address.required ? false : true"
            return-object
            single-line
            :prepend-icon="
              permanent_address.pcountry != null
                ? 'mdi-flag'
                : 'mdi-flag-variant-outline'
            "
            outlined
            hint="Country"
            persistent-hint
            @change="getStates(permanent_address.pcountry)"
          ></v-autocomplete>
        </v-col>
         <v-col cols="10" sm="5" md="5">
          <v-icon color="error" v-if="permanent_address.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="permanent_address.pstate"
            :items="state_list"
            name="pstate"
            :required="permanent_address.pstate"
            :rules="
              permanent_address.pstate
                ? [(v) => !!v || ' State is required']
                : []
            "
            :clearable="permanent_address.pstate ? false : true"
            return-object
            single-line
            :prepend-icon="
              permanent_address.pstate != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="State"
            persistent-hint
            @change="getCitiesPermanant(permanent_address.pstate)"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="permanent_address != null">
       
        <v-col cols="10" sm="5" md="5">
          <v-icon color="error" v-if="permanent_address.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="permanent_address.pcity"
            :items="cities_list_permanant"
            name="pcity"
            :required="permanent_address.pcity"
            :rules="
              permanent_address.pcity ? [(v) => !!v || ' City is required'] : []
            "
            :clearable="permanent_address.pcity ? false : true"
            return-object
            single-line
            :prepend-icon="
              permanent_address.pcity != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="City"
            persistent-hint
          ></v-autocomplete>
        </v-col>
         <!-- <v-col cols="10" sm="5" md="5">
          <v-icon color="error" v-if="permanent_address.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="permanent_address.pdistrict"
            :items="district_list"
            name="pdistrict"
            :required="permanent_address.pdistrict"
            :rules="
              permanent_address.pdistrict ? [(v) => !!v || ' District is required'] : []
            "
            :clearable="permanent_address.pdistrict ? false : true"
            return-object
            single-line
            :prepend-icon="
              permanent_address.pdistrict != null
                ? 'mdi-alpha-o-circle'
                : 'mdi-alpha-o-circle-outline'
            "
            outlined
            hint="District"
            persistent-hint
          ></v-autocomplete>
        </v-col> -->
         <v-col cols="5" sm="5" md="5">
          <v-icon color="error" v-if="permanent_address.required">*</v-icon>
          <v-text-field
            dense
            v-model="permanent_address.ppin"
            name="ppin"
            type="number"
            :required="permanent_address.required"
            :rules="
              permanent_address.required
                ? [(v) => !!v || ' Pin is required']
                : []
            "
            :clearable="permanent_address.required ? false : true"
            return-object
            single-line
            :prepend-icon="
              permanent_address.ppin != null
                ? 'mdi-map-marker'
                : 'mdi-map-marker-outline'
            "
            outlined
            hint="Pincode"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row>

         <v-row dense justify="center" v-if="permanent_address != null">
       <!-- <v-col cols="5" sm="5" md="5">
          <v-icon color="error" v-if="permanent_address.required">*</v-icon>
          <v-text-field
            dense
            v-model="permanent_address.ptaluka"
            name="ptaluka"
            :required="permanent_address.ptaluka"
            type="text"
            :rules="
              permanent_address.required ? [(v) => !!v || ' Taluka is required'] : []
            "
            :clearable="permanent_address.required ? false : true"
            return-object
            single-line
            :prepend-icon="
              permanent_address.ptaluka != null
                ? 'mdi-map-marker'
                : 'mdi-map-marker-outline'
            "
            outlined
            hint="Taluka"
            persistent-hint
          ></v-text-field>
        </v-col>-->
         <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="permanent_address.required">*</v-icon>
          <v-textarea
            dense
            :value="permanent_address.pnearest_landmark"
            v-model="permanent_address.pnearest_landmark"
            name="pnearest_landmark"
            :required="permanent_address.required"
            :rules="
              permanent_address.required
                ? [
                    (v) =>
                      !!v || permanent_address.field_display_name + ' is required',
                  ]
                : []
            "
            :clearable="permanent_address.required ? false : true"
            hint=" Nearest Landmark"
            persistent-hint
            :prepend-icon="
              permanent_address.laddress != null ? 'mdi-home' : 'mdi-home-outline'
            "
            outlined
          ></v-textarea> </v-col
      >
      </v-row> 
      <br />

      <v-row justify="center" dense>
        <v-col cols="10" sm="10" md="10">
          <div style="text-align: center">
            <v-btn
              class="mt-2"
              :color="isValid ? 'primary darken-1' : 'grey lighten-1'"
              @click="submit"
              :disabled="!isValid"
              >Save</v-btn
            >
          </div>
        </v-col></v-row
      >
    </v-form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      isValid: true,
      pladdress: false,
      loader: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      application_form_data: {
        admission_form_no: "",
        admission_form_id: "",
        display_admission_form_no: ""
      },

      local_address: null,
      permanent_address: null,

      country_list: [],
      state_list: [],
      cities_list_local: [],
      cities_list_permanant: [],
      district_list:[],
      status_list:[],
      tenant:"",preferred_communication_address:""
    };
  },
   created(){
       this.tenant = localStorage.getItem("EPS-tenant");
  },
  methods: {
     getCitiesLocal(state){
      const data = {
            state:state
      }
       axios
        .post("/admissionForm/getCityList", data)
        .then(res => {
          if (res.data.flag == "YES") {
           this.cities_list_local=res.data.cities_list
           this.cities_list_permanant=res.data.cities_list
          }else if(res.data.flag == "No"){
           this.showSnackbar("red",res.data.snackbar);
          this.cities_list_local=[]
          this.cities_list_permanant=[]
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },
     getCitiesPermanant(state){
      const data = {
            state:state
      }
       axios
        .post("/admissionForm/getCityList", data)
        .then(res => {
          if (res.data.flag == "YES") {
           this.cities_list_permanant=res.data.cities_list
          }else if(res.data.flag == "No"){
           this.showSnackbar("red",res.data.snackbar);
          this.cities_list_permanant=[]
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    getStates(country){
      //alert("country::"+country)
      const data = {
            country:country
      }
       axios
        .post("/admissionForm/getStatesList", data)
        .then(res => {
          if (res.data.flag == "YES") {
           this.state_list=res.data.state_details
          }else if(res.data.flag == "No"){
          this.showSnackbar("red",res.data.snackbar);
          this.state_list=[] //this.cities_list=[]
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    submit: function (e) {
      this.loader = false;
      var form = document.getElementById("address_form");
      var formData = new FormData(form);
      axios.post("/admissionForm/saveAddress", formData).then(
        (response) => {
          // success callback

          if (response.data.form_saved == "YES") {
            this.showSnackbar(
              "#4caf50",
              'Saved Successfully...Click on Next Tab To Continue'
            ); // show snackbar on success
          }
          this.loader = true;
          this.$store.commit("setform_progress", response.data.form_progress);
        },
        (response) => {
          // error callback
        }
      );
    },
    getform() {
      axios
        .post("/admissionForm/address", this.application_form_data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.loader = true;
            //this.form_progress=res.data.form_progress
            this.local_address = res.data.local_address;
            this.permanent_address = res.data.permanent_address;
            this.country_list = res.data.country_list;
            this.state_list = res.data.states_list;
            this.cities_list = res.data.cities_list;
            this.district_list = res.data.district_list;
            this.cities_list_local=res.data.cities_list
            this.cities_list_permanant=res.data.cities_list
            this.status_list=res.data.status_list
            this.preferred_communication_address=res.data.preferred_communication_address
            // this.pin_list = res.data.pin_list;
             //this.state_list = [];
             //this.cities_list = [];
            this.$store.commit("setform_progress", res.data.form_progress);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    copyAddress() {
      if (this.pladdress) {
        this.permanent_address.ppin = this.local_address.lpin;
        this.permanent_address.pcountry = this.local_address.lcountry;
        this.permanent_address.paddress = this.local_address.laddress;
        this.permanent_address.pcity = this.local_address.lcity;
        this.permanent_address.pstate = this.local_address.lstate;
        this.permanent_address.pdistrict = this.local_address.ldistrict;
        this.permanent_address.ptaluka = this.local_address.ltaluka;
        this.permanent_address.pnearest_landmark = this.local_address.lnearest_landmark;
      }
    },
  },
  mounted() {
    this.application_form_data = this.$store.getters.application_form_data;
    this.getform();
  },
};
</script>
